<template>
  <div class="water-mark-mask">
    <div class="row" v-for="i in 7">
      <!--这里循环生成水印文字-->
      <div class="col" v-for="i in 3" :style="{ color: color }">
        <span>{{ info }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Watermark',
  data() {
    return {

    }
  },
  props: {
    info: {
      type: String,
      default: '默认水印'
    },
    color: {
      type: String,
      default: 'rgba(0,0,0,0.06)'
    }
  },
}
</script>
<style lang="less" scoped>
.water-mark-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999999;
  /* 无视鼠标事件，相当于鼠标事件透传下去一样 */
  pointer-events: none;
  flex: 1
}

.row {
  display: flex;
  margin-bottom: 2rem;
}

.col {
  transform: rotate(-20deg);
  font-size: 0.28rem;
  margin-right: 2rem;
  white-space: nowrap;
}

.row:nth-child(even) .col:first-child {
  margin-left: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Watermark.vue